import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/initialState';
import ReactTooltip from 'react-tooltip';
import projectHelper from '../../../../services/ProjectHelper';
import { Environment } from '../../../../const/environment';
import OutOfSyncIcon from '../../../icons/OutOfSyncIcon';
import * as actions from '../../../../redux/projects/actions.projects';
import * as _ from 'lodash';
import styles from './SaveScriptsButton.module.scss';
import cn from 'classnames';
import { IProject } from '../../../../models/IProject';
import { useEffect, useState } from 'react';
import { useIsMounted } from '../../../../hooks/useIsMounted';

type SaveScriptsButtonProps = {
    isScriptSaving: boolean
    project: IProject
    environment: Environment
    updateScripts,
    className?: string
    mode: 'panel' | 'normal'
}


function SaveScriptsButton({
    isScriptSaving,
    project,
    environment,
    updateScripts,
    className = '',
    mode
}: SaveScriptsButtonProps) {

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const isMounted = useIsMounted()

    useEffect(() => {

        async function checkForChanges() {
            const hasChanges = await projectHelper.hasUnsavedChanges(project);
            if (!isMounted.current) return;
            if (hasUnsavedChanges !== hasChanges) {
                setHasUnsavedChanges(hasChanges);
            }
        }
        checkForChanges();

    }, [project, hasUnsavedChanges])

    const isLastTag = projectHelper.isLastTag(project, project[`${environment}TagId`]);
    const actualScriptsMsg = project.scriptsAreActual ? 'Scripts is sync' : 'Scripts out of sync';

    let isSaveBtnDisabled = !(isLastTag && hasUnsavedChanges && environment === Environment.Staging);

    if (isScriptSaving) {
        isSaveBtnDisabled = true;
    }

    const updateScriptsCb = () => {
        _.defer(() => {
            updateScripts({ project, environment });
        });
    }

    const isDisabled = (isSaveBtnDisabled && !isScriptSaving);

    return <div
        id="save-scripts-btn"
        className={`${cn(styles.root, styles[mode], isDisabled && styles.btnDisabled)} action-btn middle ${isScriptSaving && 'btn-loader disabled-without-opacity'} ${className}`}
        onClick={!isSaveBtnDisabled ? updateScriptsCb : undefined}>
        {((project?.scripts.length > 0 && isSaveBtnDisabled && !isScriptSaving && project.scriptsAreActual !== null) || project.scriptsAreActual === false) &&
            (project.scriptsAreActual ?
                <i title={actualScriptsMsg} className={`icon icon-checkmark ${styles.icon}`} /> :
                <span
                    data-place="top"
                    data-effect="solid"
                    data-class="tutor-dark-tooltip"
                    data-for="outOfSyncTooltip"
                    data-tip="Not synchronized">
                    <OutOfSyncIcon />
                    <ReactTooltip id="outOfSyncTooltip" />
                </span>)}
        {isScriptSaving ? 'Saving...' : (isSaveBtnDisabled ? 'Saved' : 'Save Changes')}
    </div>
}

function mapStateToProps({ projectsInfo }: IStore) {
    const project = projectsInfo.currentProject;

    return {
        project,
        isScriptSaving: projectsInfo.currentProject.isScriptSaving,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateScripts: (param) => dispatch(actions.updateScripts(param)),

    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveScriptsButton);